import { registerAlertsSubscription } from '~/app/common/packages/alerts/actions';
import { registerOrderHistorySubscription, registerCorporateOrderAnalyticsSubscription } from '~/app/common/apps/history/actions';

/*
  This action is hook into setting up all subscriptions to the vetcove-general
  socket. This function gets called in the root#componentDidMount method when
  the Vet app gets initially mounted. This way we can start listening for
  messages that get sent down the pipe before going to the necessary components
*/

export const setupAllGeneralSocketSubscriptions = () => (dispatch, getState) => {
  // Setup the alerts subscription
  registerAlertsSubscription(dispatch, getState, false);
  // Setup the Order history subscription
  registerOrderHistorySubscription(dispatch, getState);
  // Setup the Order History analytics subscription
  registerCorporateOrderAnalyticsSubscription(dispatch, getState);
};
